define((require) => {
    "use strict";

    const _                          = require("jquery");
    const SettingsView               = require("ui/settings/SettingsView");
    const template                   = require("ui/settings/manageAccount/ManageAccountSettingsView.tpl");
    const ManageAccountCompositeView = require("ui/settings/manageAccount/ManageAccountCompositeView");

    /**
     * View for defining manage account settings.
     *
     * @class ManageAccountSettingsView
     */
    return SettingsView.extend("ManageAccountSettingsView", {

        className: SettingsView.prototype.className + " manage-account-settings-view",

        template,

        regions() {
            return _.extend(SettingsView.prototype.regions, {
                manageAccountCompositeRegion: ".manage-account-composite-region"
            });
        },

        onShow() {
            this.manageAccountCompositeRegion.show(new ManageAccountCompositeView(this.options));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/manageAccount/ManageAccountSettingsView.js